export enum AddProductErrorCode {
  PRODUCT_EXISTS_IN_SUBSCRIPTION = "4",
}
